/**
 * Composing <Route> in React Router v6
 * https://gist.github.com/mjackson/d54b40a094277b7afdd6b81f51a0393f
 *
 * Upgrading from v5
 * https://reactrouter.com/docs/en/v6/upgrading/v5
 */
import { Routes, Route, redirect, Navigate, useNavigate } from 'react-router-dom';

import { Dashboard } from 'pages/Dashboard';
import { Login } from 'pages/Login';
import { NotFound } from 'pages/NotFound';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
// import { Shop } from 'pages/Shop';
import ShopDetail from 'pages/Shop/Detail';
import Reconhecer from 'pages/Reconhecer';
import Extrato from 'pages/Extrato';
import Historico from 'pages/Historico';
import Faq from 'pages/Faq';
import Regulamento from 'pages/Regulamento';
import Convidar from 'pages/Convidar';
// import { ShopTeaser } from 'pages/Shop/teaser';
import MissaoDestaque from 'pages/MissaoDestaque';
import RealizacoesPrefixo from 'pages/RealizacoesPrefixo';
import { ApreciacaoFlowGate } from 'pages/MinhaEquipe/ApreciarRealizacao';
import { FluxoNormal } from 'pages/MinhaEquipe/ApreciarRealizacao/normal';
import { FluxoMAD } from 'pages/MinhaEquipe/ApreciarRealizacao/mad';
import { Catalog } from 'pages/Catalog';
import MissaoDestaqueCreate from 'pages/MissaoDestaque/Create';
import GaleriaReconhecimento from 'pages/GaleriaReconhecimento';
import DestaquesCultura from 'pages/DestaquesCultura';
import { DestaquesCulturaDetail } from 'pages/DestaquesCultura/detail';
import { Manifesto } from 'pages/Manifesto';
import MinhaEquipe from 'pages/MinhaEquipe';
import CustomNavigationClient from 'sso/azure/CustomNavigationClient';
import { MsalProvider } from '@azure/msal-react';
import Rede from 'pages/Rede';
import { Votacao } from 'pages/Votacao';
import Catalogo from 'pages/Catalogo';
import Destaque from 'pages/Destaque';
// import AnalisarParticipacaoGerentes from 'pages/MinhaEquipe/AnalisarParticipacaoGerentes';
import AnalisarParticipacaoEquipe from 'pages/MinhaEquipe/AnalisarParticipacaoEquipe';
import Challenges from 'pages/Challenges';
import Selos from 'pages/Selos';
import ChallengesLancamento from 'pages/ChallengesLancamento';
import { Shop } from 'pages/Shop';
import { Store } from 'pages/Store';
import PontuamMasNaoAvaliam from 'pages/MinhaEquipe/PontuamMasNaoAvaliam';
import { DashboardLegacy } from 'pages/legacy/Dashboard';
import MissaoDestaqueLegacy from 'pages/legacy/MissaoDestaque';
import ExtratoLegacy from 'pages/legacy/Extrato';
import { DashboardV3 } from 'pages/v3/Dashboard';
import MissaoDestaV3 from 'pages/v3/MissaoDestaque';
import ExtratoV3 from 'pages/v3/Extrato';
import AcaoV3 from 'pages/v3/Acao';
import { ApreciarAcaoV3 } from 'pages/v3/ApreciarAcao';
import Acao from 'pages/Acao';
import AcaoCreate from 'pages/Acao/Create';
import { ApreciarAcao } from 'pages/ApreciarAcao';
import { Preference } from 'pages/Preference';
import { Notificacoes } from 'pages/Notificacoes';
import TesteSharePoint from 'pages/TesteSharepoint';
import ReconhecerJunino from 'pages/ReconhecerJunino';
import WheelItem from 'components/wheel';
import ScratchGame from 'components/scratch-game';
import { ApreciarRealizacaoLegacy } from 'pages/legacy/MinhaEquipe/ApreciarRealizacao';
import ExperienceCatalog from 'pages/ExperienceCatalog';
import ExperienceCatalogFeedbackPage from 'pages/ExperienceCatalog/feedbackPage';

export const RouteList = ({ msalInstance }: any) => {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  msalInstance.setNavigationClient(navigationClient);

  return (
    <MsalProvider instance={msalInstance}>
      <Routes>
        <Route
          path="/v2/"
          element={
            <PrivateRoute redirectTo="/login">
              <DashboardLegacy />
            </PrivateRoute>
          }
        />
        <Route
          path="/v2/realizacao-destaque"
          element={
            <PrivateRoute redirectTo="/login">
              <MissaoDestaqueLegacy />
            </PrivateRoute>
          }
        />
        <Route
          path="/v2/extrato"
          element={
            <PrivateRoute redirectTo="/login">
              <ExtratoLegacy />
            </PrivateRoute>
          }
        />

        <Route
          path="/v2/minha-equipe/validar-apreciar-realizacao"
          element={
            <PrivateRoute redirectTo="/login">
              <ApreciarRealizacaoLegacy />
            </PrivateRoute>
          }
        />

        <Route
          path="/v3/"
          element={
            <PrivateRoute redirectTo="/login">
              <DashboardV3 />
            </PrivateRoute>
          }
        />
        <Route
          path="/v3/realizacao-destaque"
          element={
            <PrivateRoute redirectTo="/login">
              <MissaoDestaV3 />
            </PrivateRoute>
          }
        />
        <Route
          path="/v3/extrato"
          element={
            <PrivateRoute redirectTo="/login">
              <ExtratoV3 />
            </PrivateRoute>
          }
        />

        <Route
          path="/v3/acao-ecoa"
          element={
            <PrivateRoute redirectTo="/login">
              <AcaoV3 />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/v3/validar-acao-ecoa"
          element={
            <PrivateRoute redirectTo="/login">
              <ApreciarAcaoV3 />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/"
          element={
            <PrivateRoute redirectTo="/login">
              <Dashboard />
            </PrivateRoute>
          }
        >
          <Route
            path="/reconhecer"
            element={
              <PrivateRoute redirectTo="/login">
                <Reconhecer />
              </PrivateRoute>
            }
          />

          <Route
            path="/reconhecer/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <Reconhecer />
              </PrivateRoute>
            }
          />

          <Route
            path="/convidar"
            element={
              <PrivateRoute redirectTo="/login">
                <Convidar />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/missao-destaque" element={<Navigate to="/realizacao-destaque" />} />

        <Route
          path="/realizacao-destaque"
          element={
            <PrivateRoute redirectTo="/login">
              <MissaoDestaque />
            </PrivateRoute>
          }
        >
          <Route
            path="/realizacao-destaque/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <MissaoDestaqueCreate />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/realizacoes-do-prefixo"
          element={
            <PrivateRoute redirectTo="/login">
              <RealizacoesPrefixo />
            </PrivateRoute>
          }
        />

        <Route
          path="/acao-ecoa"
          element={
            <PrivateRoute redirectTo="/login">
              <Acao />
            </PrivateRoute>
          }
        >
          <Route
            path="/acao-ecoa/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <AcaoCreate />
              </PrivateRoute>
            }
          />
        </Route>

        <Route
          path="/validar-acao-ecoa"
          element={
            <PrivateRoute redirectTo="/login">
              <ApreciarAcao />
            </PrivateRoute>
          }
        >
          <Route
            path="/validar-acao-ecoa/:id"
            element={
              <PrivateRoute redirectTo="/login">
                <AcaoCreate />
              </PrivateRoute>
            }
          />
        </Route>

        <Route path="/validar-destaque" element={<Navigate to="/minha-equipe/validar-apreciar-realizacao" />} />

        <Route
          path="/extrato"
          element={
            <PrivateRoute redirectTo="/login">
              <Extrato />
            </PrivateRoute>
          }
        />

        <Route path="/quadro-equipe" element={<Navigate to="/minha-equipe" />} />

        <Route path="/minha-equipe">
          <Route
            index
            element={
              <PrivateRoute redirectTo="/login">
                <MinhaEquipe />
              </PrivateRoute>
            }
          />

          <Route path="validar-apreciar-realizacao">
            <Route
              index
              element={
                <PrivateRoute redirectTo="/login">
                  <ApreciacaoFlowGate />
                </PrivateRoute>
              }
            />
            <Route
              path="diretoria-rede"
              element={
                <PrivateRoute redirectTo="/login">
                  <FluxoNormal />
                </PrivateRoute>
              }
            >
              <Route
                path=":id"
                element={
                  <PrivateRoute redirectTo="/login">
                    <MissaoDestaqueCreate />
                  </PrivateRoute>
                }
              />
            </Route>
            <Route
              path="mad"
              element={
                <PrivateRoute redirectTo="/login">
                  <FluxoMAD />
                </PrivateRoute>
              }
            >
              <Route
                path=":id"
                element={
                  <PrivateRoute redirectTo="/login">
                    <MissaoDestaqueCreate />
                  </PrivateRoute>
                }
              />
            </Route>
          </Route>

          <Route
            path="participantes-da-realizacao"
            element={
              <PrivateRoute redirectTo="/login">
                <AnalisarParticipacaoEquipe />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="dupla-lideranca"
            element={
              <PrivateRoute redirectTo="/login">
                <PontuamMasNaoAvaliam />
              </PrivateRoute>
            }
          /> */}

          {/* <Route
            path="participacao-de-gerentes"
            element={
              <PrivateRoute redirectTo="/login">
                <AnalisarParticipacaoGerentes />
              </PrivateRoute>
            }
          /> */}
        </Route>

        <Route
          path="/rede-joga-junto"
          element={
            <PrivateRoute redirectTo="/login">
              <Rede />
            </PrivateRoute>
          }
        />

        {/* <Route
          path="/historico"
          element={
            <PrivateRoute redirectTo="/login">
              <Historico />
            </PrivateRoute>
          }
        /> */}

        <Route
          path="/manifesto"
          element={
            <PrivateRoute redirectTo="/login">
              <Manifesto />
            </PrivateRoute>
          }
        />

        <Route
          path="/experiencias"
          element={
            <PrivateRoute redirectTo="/login">
              <Catalog />
            </PrivateRoute>
          }
        >
          <Route path=":id" element={<ShopDetail />} />
        </Route>

        <Route
          path="/galeria"
          element={
            <PrivateRoute redirectTo="/login">
              <GaleriaReconhecimento />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/destaques-cultura"
          element={
            <PrivateRoute redirectTo="/login">
              <DestaquesCultura />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/catalogo-de-experiencias"
          element={
            <PrivateRoute redirectTo="/login">
              <Catalogo />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/catalogo-de-experiencias-list"
          element={
            <PrivateRoute redirectTo="/login">
              <ExperienceCatalog />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="catalogo-de-experiencias-list/feedback"
          element={
            <PrivateRoute redirectTo="/login">
              <ExperienceCatalogFeedbackPage />
            </PrivateRoute>
          }
        />

        <Route
          path="/catalogo"
          element={
            <PrivateRoute redirectTo="/login">
              <Catalog />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/destaques"
          element={
            <PrivateRoute redirectTo="/login">
              <Destaque />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/desafios/:id"
          element={
            <PrivateRoute redirectTo="/login">
              <Challenges />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/desafios-lancamento"
          element={
            <PrivateRoute redirectTo="/login">
              <ChallengesLancamento />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/regulamento"
          element={
            <PrivateRoute redirectTo="/login">
              <Regulamento />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/selos"
          element={
            <PrivateRoute redirectTo="/login">
              <Selos />
            </PrivateRoute>
          }
        ></Route>

        <Route
          path="/loja"
          element={
            <PrivateRoute redirectTo="/login">
              <Store />
            </PrivateRoute>
          }
        ></Route>

        <Route path="/votacao" element={<Votacao />}></Route>

        <Route path="/ajuda" element={<Faq />} />

        {/* MINHA PREFERENCIAS */}

        <Route
          path="/minhas-preferencias"
          element={
            <PrivateRoute redirectTo="/login">
              <Preference />
            </PrivateRoute>
          }
        />

        {/* CENTRAL DE NOTIFICACOES (CENTRAL-05.1) */}

        <Route
          path="/notificacoes"
          element={
            <PrivateRoute redirectTo="/login">
              <Notificacoes />
            </PrivateRoute>
          }
        />

        <Route
          path="/teste-sharepoint"
          element={
            <PrivateRoute redirectTo="/login">
              <TesteSharePoint />
            </PrivateRoute>
          }
        />

        <Route
          path="/login"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </MsalProvider>
  );
};
